export default "__VITE_ASSET__C6CjZ3lh__"